"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var contentLineStyles = makeStyles_1.default(function () {
    var _a;
    return (_a = {
            center: {
                textAlign: 'center',
                alignItems: 'center',
            }
        },
        _a['flex-start'] = {
            textAlign: 'start',
            alignItems: 'flex-start',
        },
        _a.secondaryContent = {
            wordBreak: 'break-all',
            textAlign: 'end',
        },
        _a);
}, { name: 'Summary_ContentLine' });
exports.default = contentLineStyles;
